import { useEffect, useState } from "react";

export interface Toast {
  id: number;
  message: string;
  kind: "info" | "error" | "success";
}

let counter = 0;
let toasts: Toast[] = [];
const listeners = new Set<(t: Toast[]) => void>();

function emit() {
  listeners.forEach((l) => l(toasts));
}

export function toast(message: string, kind: Toast["kind"] = "info") {
  const t: Toast = { id: ++counter, message, kind };
  toasts = [...toasts, t];
  emit();
  setTimeout(() => {
    toasts = toasts.filter((x) => x.id !== t.id);
    emit();
  }, 4000);
}

export function useToasts() {
  const [state, setState] = useState<Toast[]>(toasts);
  useEffect(() => {
    listeners.add(setState);
    return () => {
      listeners.delete(setState);
    };
  }, []);
  return state;
}
